import React from 'react';
import {Glum} from '../../puddleglum';
import {Box, Heading, HStack, Text, VStack} from '../ui/chakra';

interface PatientCompactBannerProps {
	patient: Glum.Models.User;
}

const PatientCompactBanner = ({patient}: PatientCompactBannerProps) => (
	<Box bg='gray.50' border='1px solid' borderColor='gray.200' borderRadius='lg' p={3}>
		<VStack align='stretch' spacing={2}>
			<Heading size='sm' color='gray.800'>
				{patient.first_name} {patient.last_name}
			</Heading>
			<HStack spacing={3} flexWrap='wrap'>
				<Text fontSize='sm' color='gray.600'>
					<strong>DOB</strong>: {patient.date_of_birth ?? 'Not listed'}
				</Text>
				<Text fontSize='sm' color='gray.600'>
					<strong>Sex</strong>: {patient.sex ?? 'Not listed'}
				</Text>
				<Text fontSize='sm' color='gray.600'>
					<strong>Phone</strong>: {patient.cell_phone ?? 'Not listed'}
				</Text>
				<Text fontSize='sm' color='gray.600'>
					<strong>City</strong>:{' '}
					{patient.city ? `${patient.city}, ${patient.state}` : 'Not listed'}
				</Text>
			</HStack>
		</VStack>
	</Box>
);

export default PatientCompactBanner;
